// DO NOT EDIT -- generated from fs/services/dx-objects/spaces.proto

import { CacheOptions } from './cache.proto';
import { OrgToOrgDxObjectCopyResponse } from './copy.proto';
import { CreateFromVirtualDashboardRequest, CreateFromVirtualDashboardResponse } from './dashboards.proto';
import { Card, Dashboard, SectionCard, Space, SpaceLibraryFilter, SpaceObject, SpaceObjectOrder, SpaceSection } from './model.proto';
import { ObjectType } from './modeltypes.proto';
import * as grant from '../grant';
import * as pagination from '../../shared/pagination';
import * as protoauditstore from '../../gcloud/dstore/protoauditstore';
import * as protobuf from '../../../google/protobuf';

export namespace SpacesPublic {

  export const AddSidebarSpaceEndpoint = "/grpc/dx_objects.SpacesPublic/AddSidebarSpace";
  export function AddSidebarSpace(sender: (req: AddSidebarSpaceRequest, endpoint: string) => Promise<AddSidebarSpaceResponse>, req: AddSidebarSpaceRequest): { promise: () => Promise<AddSidebarSpaceResponse>, endpoint: string } {
    return {
      promise: () => sender(req, AddSidebarSpaceEndpoint),
      endpoint: AddSidebarSpaceEndpoint
    };
  }

  export const CreateInSpaceFromVirtualDashboardEndpoint = "/grpc/dx_objects.SpacesPublic/CreateInSpaceFromVirtualDashboard";
  export function CreateInSpaceFromVirtualDashboard(sender: (req: CreateFromVirtualDashboardRequest, endpoint: string) => Promise<CreateFromVirtualDashboardResponse>, req: CreateFromVirtualDashboardRequest): { promise: () => Promise<CreateFromVirtualDashboardResponse>, endpoint: string } {
    return {
      promise: () => sender(req, CreateInSpaceFromVirtualDashboardEndpoint),
      endpoint: CreateInSpaceFromVirtualDashboardEndpoint
    };
  }

  export const CreateSectionCardEndpoint = "/grpc/dx_objects.SpacesPublic/CreateSectionCard";
  export function CreateSectionCard(sender: (req: CreateSectionCardRequest, endpoint: string) => Promise<CreateSectionCardResponse>, req: CreateSectionCardRequest): { promise: () => Promise<CreateSectionCardResponse>, endpoint: string } {
    return {
      promise: () => sender(req, CreateSectionCardEndpoint),
      endpoint: CreateSectionCardEndpoint
    };
  }

  export const CreateSpaceEndpoint = "/grpc/dx_objects.SpacesPublic/CreateSpace";
  export function CreateSpace(sender: (req: CreateSpaceRequest, endpoint: string) => Promise<CreateSpaceResponse>, req: CreateSpaceRequest): { promise: () => Promise<CreateSpaceResponse>, endpoint: string } {
    return {
      promise: () => sender(req, CreateSpaceEndpoint),
      endpoint: CreateSpaceEndpoint
    };
  }

  export const CreateSpaceSectionEndpoint = "/grpc/dx_objects.SpacesPublic/CreateSpaceSection";
  export function CreateSpaceSection(sender: (req: CreateSpaceSectionRequest, endpoint: string) => Promise<CreateSpaceSectionResponse>, req: CreateSpaceSectionRequest): { promise: () => Promise<CreateSpaceSectionResponse>, endpoint: string } {
    return {
      promise: () => sender(req, CreateSpaceSectionEndpoint),
      endpoint: CreateSpaceSectionEndpoint
    };
  }

  export const DeleteSectionCardEndpoint = "/grpc/dx_objects.SpacesPublic/DeleteSectionCard";
  export function DeleteSectionCard(sender: (req: DeleteSectionCardRequest, endpoint: string) => Promise<{}>, req: DeleteSectionCardRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteSectionCardEndpoint),
      endpoint: DeleteSectionCardEndpoint
    };
  }

  export const DeleteSpaceEndpoint = "/grpc/dx_objects.SpacesPublic/DeleteSpace";
  export function DeleteSpace(sender: (req: DeleteSpaceRequest, endpoint: string) => Promise<{}>, req: DeleteSpaceRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteSpaceEndpoint),
      endpoint: DeleteSpaceEndpoint
    };
  }

  export const DereferenceObjectEndpoint = "/grpc/dx_objects.SpacesPublic/DereferenceObject";
  export function DereferenceObject(sender: (req: DereferenceObjectRequest, endpoint: string) => Promise<{}>, req: DereferenceObjectRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, DereferenceObjectEndpoint),
      endpoint: DereferenceObjectEndpoint
    };
  }

  export const BulkDereferenceObjectsEndpoint = "/grpc/dx_objects.SpacesPublic/BulkDereferenceObjects";
  export function BulkDereferenceObjects(sender: (req: BulkDereferenceObjectsRequest, endpoint: string) => Promise<BulkDereferenceObjectsResponse>, req: BulkDereferenceObjectsRequest): { promise: () => Promise<BulkDereferenceObjectsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, BulkDereferenceObjectsEndpoint),
      endpoint: BulkDereferenceObjectsEndpoint
    };
  }

  export const DeleteSpaceSectionEndpoint = "/grpc/dx_objects.SpacesPublic/DeleteSpaceSection";
  export function DeleteSpaceSection(sender: (req: DeleteSpaceSectionRequest, endpoint: string) => Promise<{}>, req: DeleteSpaceSectionRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteSpaceSectionEndpoint),
      endpoint: DeleteSpaceSectionEndpoint
    };
  }

  export const DuplicateSpaceDashboardCardEndpoint = "/grpc/dx_objects.SpacesPublic/DuplicateSpaceDashboardCard";
  export function DuplicateSpaceDashboardCard(sender: (req: DuplicateSpaceDashboardCardRequest, endpoint: string) => Promise<DuplicateSpaceDashboardCardResponse>, req: DuplicateSpaceDashboardCardRequest): { promise: () => Promise<DuplicateSpaceDashboardCardResponse>, endpoint: string } {
    return {
      promise: () => sender(req, DuplicateSpaceDashboardCardEndpoint),
      endpoint: DuplicateSpaceDashboardCardEndpoint
    };
  }

  export const DuplicateSpaceDashboardEndpoint = "/grpc/dx_objects.SpacesPublic/DuplicateSpaceDashboard";
  export function DuplicateSpaceDashboard(sender: (req: DuplicateSpaceDashboardRequest, endpoint: string) => Promise<DuplicateSpaceDashboardResponse>, req: DuplicateSpaceDashboardRequest): { promise: () => Promise<DuplicateSpaceDashboardResponse>, endpoint: string } {
    return {
      promise: () => sender(req, DuplicateSpaceDashboardEndpoint),
      endpoint: DuplicateSpaceDashboardEndpoint
    };
  }

  export const DuplicateSpaceSectionEndpoint = "/grpc/dx_objects.SpacesPublic/DuplicateSpaceSection";
  export function DuplicateSpaceSection(sender: (req: DuplicateSpaceSectionRequest, endpoint: string) => Promise<DuplicateSpaceSectionResponse>, req: DuplicateSpaceSectionRequest): { promise: () => Promise<DuplicateSpaceSectionResponse>, endpoint: string } {
    return {
      promise: () => sender(req, DuplicateSpaceSectionEndpoint),
      endpoint: DuplicateSpaceSectionEndpoint
    };
  }

  export const GetAllSpacesEndpoint = "/grpc/dx_objects.SpacesPublic/GetAllSpaces";
  export function GetAllSpaces(sender: (req: GetAllSpacesRequest, endpoint: string) => Promise<GetAllSpacesResponse>, req: GetAllSpacesRequest): { promise: () => Promise<GetAllSpacesResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAllSpacesEndpoint),
      endpoint: GetAllSpacesEndpoint
    };
  }

  export const GetDefaultSpaceEndpoint = "/grpc/dx_objects.SpacesPublic/GetDefaultSpace";
  export function GetDefaultSpace(sender: (req: GetDefaultSpaceRequest, endpoint: string) => Promise<GetDefaultSpaceResponse>, req: GetDefaultSpaceRequest): { promise: () => Promise<GetDefaultSpaceResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetDefaultSpaceEndpoint),
      endpoint: GetDefaultSpaceEndpoint
    };
  }

  export const GetLibraryViewEndpoint = "/grpc/dx_objects.SpacesPublic/GetLibraryView";
  export function GetLibraryView(sender: (req: GetLibraryViewRequest, endpoint: string) => Promise<GetLibraryViewResponse>, req: GetLibraryViewRequest): { promise: () => Promise<GetLibraryViewResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetLibraryViewEndpoint),
      endpoint: GetLibraryViewEndpoint
    };
  }

  export const GetPersonalizedSidebarEndpoint = "/grpc/dx_objects.SpacesPublic/GetPersonalizedSidebar";
  export function GetPersonalizedSidebar(sender: (req: GetPersonalizedSidebarRequest, endpoint: string) => Promise<GetPersonalizedSidebarResponse>, req: GetPersonalizedSidebarRequest): { promise: () => Promise<GetPersonalizedSidebarResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetPersonalizedSidebarEndpoint),
      endpoint: GetPersonalizedSidebarEndpoint
    };
  }

  export const GetSpaceEndpoint = "/grpc/dx_objects.SpacesPublic/GetSpace";
  /** GetSpace fetches the Space metadata */
  export function GetSpace(sender: (req: GetSpaceRequest, endpoint: string) => Promise<GetSpaceResponse>, req: GetSpaceRequest): { promise: () => Promise<GetSpaceResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetSpaceEndpoint),
      endpoint: GetSpaceEndpoint
    };
  }

  export const GetSpaceCardViewEndpoint = "/grpc/dx_objects.SpacesPublic/GetSpaceCardView";
  /**
   * GetSpaceCardView returns the sections and cards needed to render the card
   * view tab, but does not return the Space metadata
   */
  export function GetSpaceCardView(sender: (req: GetSpaceCardViewRequest, endpoint: string) => Promise<GetSpaceCardViewResponse>, req: GetSpaceCardViewRequest): { promise: () => Promise<GetSpaceCardViewResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetSpaceCardViewEndpoint),
      endpoint: GetSpaceCardViewEndpoint
    };
  }

  export const GetSpaceForObjectEndpoint = "/grpc/dx_objects.SpacesPublic/GetSpaceForObject";
  /**
   * GetSpaceForObjects fetches the Space metadata for the Space that owns the
   * specified object. If no owning Space is found, will return the default
   * Space.
   */
  export function GetSpaceForObject(sender: (req: GetSpaceForObjectRequest, endpoint: string) => Promise<GetSpaceForObjectResponse>, req: GetSpaceForObjectRequest): { promise: () => Promise<GetSpaceForObjectResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetSpaceForObjectEndpoint),
      endpoint: GetSpaceForObjectEndpoint
    };
  }

  export const BatchGetOwnedSpacesForObjectsEndpoint = "/grpc/dx_objects.SpacesPublic/BatchGetOwnedSpacesForObjects";
  /**
   * BatchGetOwnedSpacesForObjects fetches the owning Space id for specified objects
   * and a list of unique spaces for the objects. If no owning Space is found, will return the default Space.
   */
  export function BatchGetOwnedSpacesForObjects(sender: (req: BatchGetOwnedSpacesForObjectsRequest, endpoint: string) => Promise<BatchGetOwnedSpacesForObjectsResponse>, req: BatchGetOwnedSpacesForObjectsRequest): { promise: () => Promise<BatchGetOwnedSpacesForObjectsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, BatchGetOwnedSpacesForObjectsEndpoint),
      endpoint: BatchGetOwnedSpacesForObjectsEndpoint
    };
  }

  export const MoveSectionCardEndpoint = "/grpc/dx_objects.SpacesPublic/MoveSectionCard";
  export function MoveSectionCard(sender: (req: MoveSectionCardRequest, endpoint: string) => Promise<MoveSectionCardResponse>, req: MoveSectionCardRequest): { promise: () => Promise<MoveSectionCardResponse>, endpoint: string } {
    return {
      promise: () => sender(req, MoveSectionCardEndpoint),
      endpoint: MoveSectionCardEndpoint
    };
  }

  export const MoveSpaceSectionEndpoint = "/grpc/dx_objects.SpacesPublic/MoveSpaceSection";
  export function MoveSpaceSection(sender: (req: MoveSpaceSectionRequest, endpoint: string) => Promise<MoveSpaceSectionResponse>, req: MoveSpaceSectionRequest): { promise: () => Promise<MoveSpaceSectionResponse>, endpoint: string } {
    return {
      promise: () => sender(req, MoveSpaceSectionEndpoint),
      endpoint: MoveSpaceSectionEndpoint
    };
  }

  export const OwnObjectEndpoint = "/grpc/dx_objects.SpacesPublic/OwnObject";
  export function OwnObject(sender: (req: OwnObjectRequest, endpoint: string) => Promise<OwnObjectResponse>, req: OwnObjectRequest): { promise: () => Promise<OwnObjectResponse>, endpoint: string } {
    return {
      promise: () => sender(req, OwnObjectEndpoint),
      endpoint: OwnObjectEndpoint
    };
  }

  export const BulkOwnObjectsEndpoint = "/grpc/dx_objects.SpacesPublic/BulkOwnObjects";
  export function BulkOwnObjects(sender: (req: BulkOwnObjectsRequest, endpoint: string) => Promise<BulkOwnObjectsResponse>, req: BulkOwnObjectsRequest): { promise: () => Promise<BulkOwnObjectsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, BulkOwnObjectsEndpoint),
      endpoint: BulkOwnObjectsEndpoint
    };
  }

  export const ReferenceObjectEndpoint = "/grpc/dx_objects.SpacesPublic/ReferenceObject";
  export function ReferenceObject(sender: (req: ReferenceObjectRequest, endpoint: string) => Promise<ReferenceObjectResponse>, req: ReferenceObjectRequest): { promise: () => Promise<ReferenceObjectResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ReferenceObjectEndpoint),
      endpoint: ReferenceObjectEndpoint
    };
  }

  export const BulkReferenceObjectsEndpoint = "/grpc/dx_objects.SpacesPublic/BulkReferenceObjects";
  export function BulkReferenceObjects(sender: (req: BulkReferenceObjectsRequest, endpoint: string) => Promise<BulkReferenceObjectsResponse>, req: BulkReferenceObjectsRequest): { promise: () => Promise<BulkReferenceObjectsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, BulkReferenceObjectsEndpoint),
      endpoint: BulkReferenceObjectsEndpoint
    };
  }

  export const RemoveSidebarSpaceEndpoint = "/grpc/dx_objects.SpacesPublic/RemoveSidebarSpace";
  export function RemoveSidebarSpace(sender: (req: RemoveSidebarSpaceRequest, endpoint: string) => Promise<RemoveSidebarSpaceResponse>, req: RemoveSidebarSpaceRequest): { promise: () => Promise<RemoveSidebarSpaceResponse>, endpoint: string } {
    return {
      promise: () => sender(req, RemoveSidebarSpaceEndpoint),
      endpoint: RemoveSidebarSpaceEndpoint
    };
  }

  export const UpdateSectionCardEndpoint = "/grpc/dx_objects.SpacesPublic/UpdateSectionCard";
  export function UpdateSectionCard(sender: (req: UpdateSectionCardRequest, endpoint: string) => Promise<UpdateSectionCardResponse>, req: UpdateSectionCardRequest): { promise: () => Promise<UpdateSectionCardResponse>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateSectionCardEndpoint),
      endpoint: UpdateSectionCardEndpoint
    };
  }

  export const UpdateSpaceEndpoint = "/grpc/dx_objects.SpacesPublic/UpdateSpace";
  export function UpdateSpace(sender: (req: UpdateSpaceRequest, endpoint: string) => Promise<UpdateSpaceResponse>, req: UpdateSpaceRequest): { promise: () => Promise<UpdateSpaceResponse>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateSpaceEndpoint),
      endpoint: UpdateSpaceEndpoint
    };
  }

  export const UpdateSpaceSectionEndpoint = "/grpc/dx_objects.SpacesPublic/UpdateSpaceSection";
  export function UpdateSpaceSection(sender: (req: UpdateSpaceSectionRequest, endpoint: string) => Promise<UpdateSpaceSectionResponse>, req: UpdateSpaceSectionRequest): { promise: () => Promise<UpdateSpaceSectionResponse>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateSpaceSectionEndpoint),
      endpoint: UpdateSpaceSectionEndpoint
    };
  }
}

export namespace SpacesCopyPublic {

  export const CopySpaceToOrgEndpoint = "/grpc/dx_objects.SpacesCopyPublic/CopySpaceToOrg";
  /**
   * CopySpaceToOrg allows copies a space and all child objects to a different org. Any referenced child
   * object will be created once. If running again with the same space, this will not recreate objects that were already created.
   */
  export function CopySpaceToOrg(sender: (req: CopySpaceToOrgRequest, endpoint: string) => Promise<OrgToOrgDxObjectCopyResponse>, req: CopySpaceToOrgRequest): { promise: () => Promise<OrgToOrgDxObjectCopyResponse>, endpoint: string } {
    return {
      promise: () => sender(req, CopySpaceToOrgEndpoint),
      endpoint: CopySpaceToOrgEndpoint
    };
  }
}

export interface UserAccess {
  canRead: boolean;
  canUpdate: boolean;
  canDelete: boolean;
}

export interface CopySpaceToOrgRequest {
  sourceOrgId: string;
  destinationOrgId: string;
  spaceIds: string[];
  /**
   * If provided, it will delete and recreate the given space IDs. The underlying objects themselves will not be deleted
   * and instead will just be reassigned to the new space. These space IDs must have been created via starter kits
   * or else they will be ignored.
   */
  recreateDestSpaceIds: string[];
  /**
   * If provided, it will delete and recreate the given dashboard IDs. The underlying objects themselves will not be deleted
   * and instead will just be reassigned to the new dashboard. These dashboard IDs must have been created via starter kits
   * or else they will be ignored.
   */
  recreateDestDashboardIds: protobuf.int64[];
}

export interface AddSidebarSpaceRequest {
  orgId: string;
  spaceId: string;
}

export interface AddSidebarSpaceResponse {
}

export interface CreateSectionCardRequest {
  orgId: string;
  sectionId: string;
  dxObjectType: ObjectType;
  dxObjectId: string;
  format: number;
  chartType: number;
  funnelMetricType: number;
  markdown: string;
}

export interface CreateSectionCardResponse {
  card: SectionCard | null;
}

export interface CreateSpaceRequest {
  orgId: string;
  name: string;
  description: string;
  /** The hex color code */
  color: string;
}

export interface CreateSpaceResponse {
  space: Space | null;
}

export interface CreateSpaceSectionRequest {
  orgId: string;
  name: string;
  spaceId: string;
  /**
   * Set the index of the new section, which will shift other sections to
   * accommodate it.
   */
  index: number;
}

export interface CreateSpaceSectionResponse {
  section: SpaceSection | null;
}

export interface DeleteSectionCardRequest {
  orgId: string;
  id: string;
}

export interface DeleteSpaceRequest {
  orgId: string;
  id: string;
  /**
   * The Space to move all of the objects to.
   * If unset, will move objects to the default space.
   */
  destinationSpaceId: string;
}

export interface DereferenceObjectRequest {
  orgId: string;
  spaceId: string;
  dxObjectId: string;
  dxObjectType: ObjectType;
}

export interface BulkDereferenceObjectsRequest {
  orgId: string;
  objects: DereferenceObjectRequest[];
}

export interface BulkDereferenceObjectsResponse {
  failedObjects: MaybeSpaceObject[];
}

export interface DuplicateSpaceDashboardCardRequest {
  orgId: string;
  dashboardId: protobuf.int64;
  cardId: protobuf.int64;
  toDashboardId: protobuf.int64;
  name: string;
  description: string;
}

export interface DuplicateSpaceDashboardCardResponse {
  card: Card | null;
}

export interface DuplicateSpaceDashboardRequest {
  orgId: string;
  id: protobuf.int64;
  visibility: protoauditstore.Visibility;
  spaceId: string;
}

export interface DuplicateSpaceDashboardResponse {
  dashboard: Dashboard | null;
}

export interface DeleteSpaceSectionRequest {
  orgId: string;
  id: string;
}

export interface DuplicateSpaceSectionRequest {
  orgId: string;
  id: string;
  /**
   * Set the index of the new section, which will shift other sections to
   * accommodate it.
   */
  index: number;
}

export interface DuplicateSpaceSectionResponse {
  sectionId: string;
}

export interface GetAllSpacesRequest {
  orgId: string;
  query: string;
  includeAccessInfo: boolean;
}

export interface GetAllSpacesResponse {
  spaces: Space[];
  accessInfo: { [key: string]: grant.ListAccessForSpaceResponse };
}

export interface GetDefaultSpaceRequest {
  orgId: string;
}

export interface GetDefaultSpaceResponse {
  defaultSpace: Space | null;
}

export interface GetLibraryViewRequest {
  orgId: string;
  /**
   * If specified, the result set will only contain results that are in this
   * space, both owned and referenced.
   */
  id: string;
  order: SpaceObjectOrder | null;
  query: string;
  pageInfo: pagination.PageInfoRequest | null;
  filters: SpaceLibraryFilter[];
  cacheOptions: CacheOptions | null;
  /** If specified, the result set will only contain results owned by this space. */
  excludeReferences: boolean;
}

export interface GetLibraryViewResponse {
  objects: SpaceObject[];
  pageInfo: pagination.PageInfoResponse | null;
}

export interface GetPersonalizedSidebarRequest {
  orgId: string;
}

export interface GetPersonalizedSidebarResponse {
  /** @deprecated */
  spaces: Space[];
  hiddenSpaces: Space[];
  visibleSpaces: Space[];
}

export interface GetSpaceRequest {
  orgId: string;
  id: string;
}

export interface GetSpaceResponse {
  space: Space | null;
  userAccess: UserAccess | null;
}

export interface GetSpaceCardViewRequest {
  orgId: string;
  id: string;
}

export interface GetSpaceCardViewResponse {
  sections: SpaceSection[];
  cardLimit: protobuf.int64;
}

export interface GetSpaceForObjectRequest {
  orgId: string;
  dxObjectId: string;
  dxObjectType: ObjectType;
}

export interface GetSpaceForObjectResponse {
  space: Space | null;
  referencedIn: Space[];
}

export interface BatchGetOwnedSpacesForObjectsRequest {
  orgId: string;
  dxObjectIds: string[];
}

export interface BatchGetOwnedSpacesForObjectsResponse {
  dxObjectIdToSpaceId: { [key: string]: string };
  uniqueSpaceIds: string[];
}

export interface MoveSectionCardRequest {
  orgId: string;
  id: string;
  /** The new display index for the card */
  newIndex: number;
}

export interface MoveSectionCardResponse {
  section: SpaceSection | null;
}

export interface MoveSpaceSectionRequest {
  orgId: string;
  id: string;
  /** The new display index for the section */
  newIndex: number;
}

export interface MoveSpaceSectionResponse {
  space: Space | null;
}

export interface OwnObjectRequest {
  orgId: string;
  spaceId: string;
  dxObjectId: string;
  dxObjectType: ObjectType;
  /**
   * If true, a reference to the object will remain in the current space and
   * reference the object from the new space.
   */
  keepReference: boolean;
}

export interface OwnObjectResponse {
  object: SpaceObject | null;
}

export interface BulkOwnObjectsRequest {
  orgId: string;
  objects: OwnObjectRequest[];
}

export interface BulkOwnObjectsResponse {
  objects: MaybeSpaceObject[];
}

export interface MaybeSpaceObject {
  spaceId: string;
  dxObjectId: string;
  dxObjectType: ObjectType;
  failed?: boolean;
  object?: SpaceObject | null;
}

export namespace MaybeSpaceObject {
  export enum failed_or_object {
    failed = 4,
    object = 5
  }

  export function failed_or_object_oneof(m: MaybeSpaceObject): { opt: failed_or_object.failed, val: boolean } | { opt: failed_or_object.object, val: SpaceObject } | null {
    if (m.failed != null) { return { opt: failed_or_object.failed, val: m.failed } }
    if (m.object != null) { return { opt: failed_or_object.object, val: m.object } }
    return null;
  }
}

export interface ReferenceObjectRequest {
  orgId: string;
  spaceId: string;
  dxObjectId: string;
  dxObjectType: ObjectType;
}

export interface ReferenceObjectResponse {
  object: SpaceObject | null;
}

export interface BulkReferenceObjectsRequest {
  orgId: string;
  objects: ReferenceObjectRequest[];
}

export interface BulkReferenceObjectsResponse {
  objects: MaybeSpaceObject[];
}

export interface RemoveSidebarSpaceRequest {
  orgId: string;
  spaceId: string;
}

export interface RemoveSidebarSpaceResponse {
}

export interface UpdateSectionCardRequest {
  orgId: string;
  id: string;
  dxObjectType: ObjectType;
  dxObjectId: string;
  format: number;
  chartType: number;
  funnelMetricType: number;
  markdown: string;
}

export interface UpdateSectionCardResponse {
  card: SectionCard | null;
}

export interface UpdateSpaceRequest {
  orgId: string;
  id: string;
  name: string;
  description: string;
  /** The hex color code */
  color: string;
}

export interface UpdateSpaceResponse {
  space: Space | null;
}

export interface UpdateSpaceSectionRequest {
  orgId: string;
  id: string;
  name: string;
  spaceId: string;
}

export interface UpdateSpaceSectionResponse {
  section: SpaceSection | null;
}
